import { render, staticRenderFns } from "./ComprobanteModal2.vue?vue&type=template&id=00c53b1c"
import script from "./ComprobanteModal2.vue?vue&type=script&lang=js"
export * from "./ComprobanteModal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports